<template>
  <div class="">
    <div class="lg:px-2 md:px-2 px-2">
      <div>
        <div class="text-center flex item-center justify-center">
          <img class="google-sign-in-logo" src="../img/google.png" />
        </div>
        <div class="text-center flex item-center justify-center">
          <b-button variant="primary" class="mr-4 mt-4" @click="getAuth"
            >Google Auth</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import axios from "axios";
export default {
  data() {
    return {
      isshowform: false,
    };
  },
  methods: {
    async getAuth() {
      try {
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$webURL + "/schedule-page",
          scopes: [
            "https://www.googleapis.com/auth/calendar",
            "https://www.googleapis.com/auth/calendar.events",
          ],
        });
        // console.log(this.$webURL+'/schedule-page', "Window location href");
        window.open(res.data, "_self");
      } catch (error) {
        console.log(error);
      }
    },
    async getToken(code) {
      try {
        let data = await this.$store.dispatch("google/getToken", {
          redirectURL: this.$webURL + "/schedule-page",
          code: code,
        });
        if (data.code === 200) {
          window.localStorage.setItem("isGoogleSigned", true);
          this.$store.commit("google/SET_GOOGLE_AUTH", {
            access_token: data.data,
            scope: decodeURIComponent(this.$route.query.scope),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    closeModal() {
      this.$emit("close");
    },
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },

    ...mapState("google", ["googleAuth"]),
  },
  async mounted() {},
};
</script>
<style>
.mx-datepicker {
  width: 100%;
}
.mx-input {
  height: 42px !important;
}
.mx-input:disabled {
  color: #525f7f;
  background-color: #e9ecef;
}
.col-form-label {
  padding-bottom: 3px !important;
}
.google-sign-in-logo {
  width: 70px;
  margin-left: -20px;
}
</style>
